import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { useTranslation as n } from "../../../../../hooks/useTranslation/index.js";
import { HeaderAlertContainer as i, FlagIcon as l, HeaderAlertText as m } from "./style.js";
import { Flag as d } from "@pelando/fontawesome/icons";
const f = ({ matchedKeyword: o, disabled: r }) => {
  const { t: a } = n("common");
  return /* @__PURE__ */ e(i, { children: [
    /* @__PURE__ */ t(l, { icon: d, "aria-disabled": r }),
    /* @__PURE__ */ e(m, { "aria-disabled": r, children: [
      a("header-alert-text"),
      /* @__PURE__ */ t("strong", { children: o })
    ] })
  ] });
};
export {
  f as HeaderAlert
};
